import { applyMiddleware, createStore } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import { browserHistory } from 'react-router'
import thunk from 'redux-thunk'
import rootReducer from 'reducers/index'

/**
 * Configures store for production
 * @param {Object} preloadedState - aplication initial state
 * @return {Object} store
 */
const configureStore = (preloadedState) => {
  // Sets store middleware
  const middleware = applyMiddleware(thunk, routerMiddleware(browserHistory))

  const store = createStore(rootReducer, preloadedState, middleware)

  return store
}

export default configureStore
